import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const TipoFormGroup = ({ iTouched, iError, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO' htmlFor='select-tipo' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='tipo'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='select-tipo'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            >
              <option value='TODAS'>Todas</option>
              <option value='2DIGITOS'>2 Digitos</option>
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoFormGroup)
